// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1WhPt","list":"PatternAutocomplete_list__wrWc0"};